/*
  The Inc VAT / Ex VAT price switch.

  Every price on the site is printed both ways by snippets/sss-vat-price.liquid;
  this only decides which one leads, by setting html[data-vat]. The layout sets
  the attribute before first paint from the stored choice, so a returning trade
  buyer never sees the inclusive figures flash first.

  The choice is kept in localStorage and mirrored to a cookie, so it holds for
  the rest of the visit and the next one. New visitors always start on inc VAT.

  window.SSSVat lets script-painted prices (the product configurator's running
  total) print the same pair the Liquid snippet does.
*/
(function () {
  var KEY = 'sss_vat';
  var RATE = 1.2;
  var root = document.documentElement;

  function mode() {
    return root.dataset.vat === 'ex' ? 'ex' : 'inc';
  }

  function store(v) {
    try { localStorage.setItem(KEY, v); } catch (e) { /* private window */ }
    document.cookie = KEY + '=' + v + ';path=/;max-age=31536000;samesite=lax';
  }

  function paint() {
    var m = mode();
    document.querySelectorAll('[data-vat-set]').forEach(function (b) {
      b.setAttribute('aria-pressed', String(b.dataset.vatSet === m));
    });
    document.querySelectorAll('[data-vat-label]').forEach(function (el) {
      el.textContent = m === 'ex' ? el.dataset.vatEx : el.dataset.vatInc;
    });
  }

  function set(v) {
    if (v === 'ex') root.dataset.vat = 'ex';
    else delete root.dataset.vat;
    store(v);
    paint();
  }

  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-vat-set]');
    if (!b) return;
    e.preventDefault();
    set(b.dataset.vatSet);
  });

  function money(pence, fmt) {
    var v = (pence / 100).toFixed(2);
    return (fmt || '£{{amount}}')
      .replace(/\{\{\s*amount\s*\}\}/, v.replace(/\B(?=(\d{3})+(?!\d))/g, ','))
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, Math.round(pence / 100))
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, v.replace('.', ','));
  }

  window.SSSVat = {
    ex: function (pence) { return Math.round(pence / RATE); },
    money: money,
    /* the same markup the Liquid snippet prints */
    html: function (pence, fmt, prefix) {
      var pre = prefix ? '<i class="vatp__pre">' + prefix + '</i> ' : '';
      return '<span class="vatp__inc">' + pre + '<b>' + money(pence, fmt) + '</b> <i class="vatp__t">inc VAT</i></span>' +
             '<span class="vatp__ex">' + pre + '<b>' + money(Math.round(pence / RATE), fmt) + '</b> <i class="vatp__t">ex VAT</i></span>';
    }
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', paint);
  else paint();
})();
